// Fee wording helpers (Oct 10). A missing fee used to fall back to 9.99,
// which showed the wrong amount for a 48-hour watch (US$5.99). If the fee
// is unknown, these return plain wording with no number instead.
export function feeUsdNumber(value) {
  const n = Number(value);
  return value != null && Number.isFinite(n) ? n : null;
}

// "US$5.99 fee", or just "fee" if the amount is unknown.
export function feeLabel(value) {
  const n = feeUsdNumber(value);
  return n == null ? 'fee' : `US$${n.toFixed(2)} fee`;
}

// " (US$5.99)", or "" if the amount is unknown.
export function feeParen(value) {
  const n = feeUsdNumber(value);
  return n == null ? '' : ` (US$${n.toFixed(2)})`;
}

// Outcome of a finished Price Watch, for colouring (Oct 10, navy and yellow):
//   'nothing' = you paid nothing (price moved out of the fee range, a refund
//               after proof, or a free trial)  -> navy with yellow text
//   'fee'     = the fee was charged                -> yellow with navy text
//   'other'   = cancelled / unknown                -> slate with white text
export function watchOutcome(status, paymentStatus, feeAmount) {
  if (paymentStatus === 'kept_then_refunded_by_evidence' || status === 'refunded') return 'nothing';
  if (status === 'kept') return (feeAmount != null && Number(feeAmount) === 0) ? 'nothing' : 'fee';
  return 'other';
}

export const OUTCOME_STYLE = {
  nothing: { bg: '#1E3A5F', fg: '#F4C11C', btn: 'rgba(255,255,255,0.2)' },
  fee:     { bg: '#F4C11C', fg: '#1E3A5F', btn: 'rgba(30,58,95,0.15)' },
  other:   { bg: '#5A6B78', fg: '#FFFFFF', btn: 'rgba(255,255,255,0.2)' },
};

// " (US$5.99)" for a local currency, nothing at all when the amount is
// already in US dollars (it would just repeat itself).
export function usdParen(currency, usdText) {
  return String(currency || '').toUpperCase() === 'USD' ? '' : ` (US$${usdText})`;
}
